<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(19)"
      :class="index == 19 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 19" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 19"
      />
      <div>生产线</div>
    </div>
    <div
      class="button"
      @click="selectMenu(20)"
      :class="index == 20 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 20" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 20"
      />
      <div>库存区</div>
    </div>
    <div
      class="button"
      @click="selectMenu(21)"
      :class="index == 21 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 21" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 21"
      />
      <div>视频监控</div>
    </div>
    <div
      class="button"
      @click="selectMenu(22)"
      :class="index == 22 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 22" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 22"
      />
      <div>入库信息</div>
    </div>
    <div
      class="button"
      @click="selectMenu(23)"
      :class="index == 23 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 23" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 23"
      />
      <div>出库信息</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
<style>

</style>
